import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import './FollowButton.css';

function FollowButton({ userId, currentUserId, onFollowChange, size = 'small' }) {
  const [isFollowing, setIsFollowing] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkFollowStatus = useCallback(async () => {
    try {
      const response = await axios.get(`/api/follow/user/${userId}/is-following`);
      setIsFollowing(response.data);
    } catch (error) {
      console.error('Error checking follow status:', error);
    }
  }, [userId]);

  useEffect(() => {
    if (userId && currentUserId && userId !== currentUserId) {
      checkFollowStatus();
    }
  }, [userId, currentUserId, checkFollowStatus]);

  const handleFollow = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;

    setLoading(true);
    try {
      await axios.post(`/api/follow/user/${userId}`);
      const statusResponse = await axios.get(`/api/follow/user/${userId}/is-following`);
      setIsFollowing(statusResponse.data);
      if (onFollowChange) onFollowChange();
    } catch (error) {
      console.error('Error toggling follow:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!userId || userId === currentUserId) return null;

  return (
    <button
      className={`follow-button ${size} ${isFollowing ? 'following' : ''}`}
      onClick={handleFollow}
      disabled={loading}
    >
      {loading ? '...' : isFollowing ? 'Following' : 'Follow'}
    </button>
  );
}

export default FollowButton;
